import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { FraccionamientoBienCulturalInterface } from '../models/fracciomiento.model';

@Injectable({providedIn: 'root'})
export class IntegracionesFraccionamientoService {

    constructor(private apiService: ApiService ) { }
    
    postFraccionamientoIntegracion(body:FraccionamientoBienCulturalInterface){
            const url= `/fraccionamiento_integracion` 
            return new Promise((resolve, reject)=>{
                this.apiService.PostMethod(url, body, {}, 'Error al Guardar los datos.')
                    .subscribe(response => {
                        resolve(response)  
                    }, error => {
                        reject(error)
                    })
            })
        }
}